exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".download-item{width:100%;height:80px;display:flex;flex-direction:row;align-items:center}.download-item__body{width:100%;height:inherit;display:flex;flex-direction:row;align-items:center}.download-item__type-icon{width:28px;height:28px;margin-left:0;flex-shrink:0}.download-item__details{font-size:16px;line-height:24px;font-weight:bold;margin-left:16px}.download-item__details__finer{font-size:12px;line-height:16px;font-weight:normal;color:#727e82;text-transform:uppercase}.download-item__wrapper hr{margin:0}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};